// extracted by mini-css-extract-plugin
export default {"Spinnerborder":"Spinner_Spinnerborder__hsOq9","spinner-border":"Spinner_spinner-border__ZEpTN","center":"Spinner_center__MFMm7"};